// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The type of filter mode to use when choosing which components to display. */
export enum FilterMode {
    /** A simple filter editor should be used, with a minimal UI. */
    Simple = 0,

    /** A more advanced editor should be used that provides all available options. */
    Advanced = 1
}
